export type NativeAcquisitionEvent = 'app_welcome_view'|'app_need_service_click'|'app_provide_services_click'|'app_how_it_works_click'|'app_signin_click'|'app_customer_signup_start'|'app_provider_signup_start'

export function trackNativeAcquisition(event: NativeAcquisitionEvent, locale: 'en'|'es') {
  window.dispatchEvent(new CustomEvent('propertyready:native-acquisition', { detail: { event, locale, occurred_at:new Date().toISOString() } }))
  if (import.meta.env.DEV) console.info('[native-acquisition]', { event, locale })
}
